import { Client } from 'hooks/webapi/useClient';
import { LatestLoan } from 'hooks/webapi/useLatestLoan';

const DEFAULT_VALUE = 850;

export const isVoluntaryBannerAvailable = (
  client: Client | undefined | null,
  latestLoan?: LatestLoan | null | undefined,
) =>
  client &&
  client?.totalCreditLimit >= DEFAULT_VALUE &&
  !client?.hasActiveIdDocument &&
  Boolean(latestLoan) &&
  !latestLoan?.overDueDays;

export const getIsExistingUser = (client: Client | undefined | null) =>
  !!client?.identified;
